interface AuthConfig {
    CLIENT_ID: string;
    CLIENT_DOMAIN: string;
    AUDIENCE: string;
    REDIRECT: string;
    SCOPE: string;
  }
  
  export const AUTH_CONFIG: AuthConfig = {
    CLIENT_ID: 'YOUR-AUTH0-CLIENT-ID',
    CLIENT_DOMAIN: 'YOUR-AUTH0-DOMAIN', // e.g., you.auth0.com
    AUDIENCE: 'YOUR-AUTH0-API-IDENTIFIER', // e.g., http://localhost:3001
    REDIRECT: 'http://localhost:4200/callback',
    SCOPE: 'openid profile email'
  };


// WEBPACK FOOTER //
// ./src/app/auth/auth-config.ts